module.exports = __webpack_public_path__ + "static/media/Soak.da3833fe.svg";